import { getRefreshTokenFact, getParticipantRefreshTokenFact } from "./auth";
import localStorageService from "../services/localStorage";
import { checkUsername, generatejwttoken, participantManagement, appointmentStatus, COGNITO_API_US_WEB_ROOT, pool, metaInfo, provider, COGNITO_API_WEB_ROOT, API_ROOT, API_ROOT_V2, API_ROOT_V3, API_ROOT_V4, API_PARTICIPANT_PORTAL, API_PARTICIPANT_PORTAL_V4 } from "./urls";
import eventBus from "@/eventBus";
import XssFilterUtility from "../utils/xssFilter";

function showLoader(request) {
  let show = true;
  if (request.params.isTelehealthSearch) {
    show = false;
  } else if (request.url.includes("isOnlyCheck=true")) {
    show = false;
  } else if (request.url.includes(checkUsername)) {
    show = false;
  } else if (request.url.includes(appointmentStatus)) {
    show = false;
  } else if (request.url.includes("document{/documentId}/pagination?page={page}") && request.method === "GET") {
    show = false;
  } else if (request.url.includes("pagination?studyId={studyId}&page={page}") && request.method === "GET") {
    show = false;
  } else if (request.url.includes("{/studyId}/sites{/siteId}/documents?studyId={studyId}&siteId={siteId}") && request.method === "GET") {
    show = false;
  } else if (request.url.includes("/notification/unReadCount") && request.method === "GET") {
    show = false;
  } else if (window.location.href.includes("participants/list") && request.method === "GET" && !request.url.includes("studies/participants/pagination")) {
    show = false;
  }
  return show;
}

function hideLoader() {
  let hide = true;
  if (window.location.href.includes("automatic_off_loader=false")) {
    hide = false;
  }
  return hide;
}

export function setupInterceptors({ http, toastr, store, VueInstance }) {
  http.interceptors.push((requestOld, next) => {
    let request = requestOld;
    const electronicSignatureSignIn = !!(request.body && request.body.electronicSignatureSignIn);
    if (request.url && request.url.indexOf("refresh") < 0) {
      const url = window.location.href;
      if ((request.url.indexOf("/mobilejson") > -1 || request.url.indexOf("/learnmore/videos") > -1 || request.url.indexOf("/country") > -1 || request.url.indexOf("/languages") > -1 || request.url.indexOf("/mobile/studyfeatures") > -1) && url.includes("/participants/web/")) {
        request.headers.set("Authorization", null);
      } else if (request.url.indexOf("api.opentok.com") > -1) {
        request.headers.set("x-opentok-auth", localStorageService.getItem("ot-jwt-token")); // adding Opentok jwt token
      } else {
        request.headers.set("Authorization", localStorageService.getItem("token"));
        request.uploadProgress = e => {
          if (e.lengthComputable) {
            eventBus.$emit("handleUploadProgress", e);
          }
        };
      }

      if (request.url.indexOf(API_ROOT) > -1 || request.url.indexOf(API_ROOT_V2) > -1 || request.url.indexOf(API_ROOT_V3) > -1 || request.url.indexOf(API_ROOT_V4) > -1 || request.url.indexOf(API_PARTICIPANT_PORTAL) > -1 || request.url.indexOf(API_PARTICIPANT_PORTAL_V4) > -1) {
        request.headers.set("thread-x-api-key", `${process.env.VUE_TH_X_API_KEY}`);
      }
      if (request.url.indexOf(COGNITO_API_US_WEB_ROOT) > -1 && request.url.indexOf(pool) > -1) {
        request.headers.set("x-api-key", `${process.env.VUE_APP_X_API_KEY}`);
      }
      if (request.url.indexOf(COGNITO_API_WEB_ROOT) > -1 && (request.url.indexOf(pool) > -1 || request.url.indexOf(`${pool}/${metaInfo}`) || request.url.indexOf(`${provider}/${metaInfo}`))) {
        request.headers.set("x-api-key", `${process.env.VUE_APP_X_API_KEY_COGNITO_AUTH}`);
      }
      if (request.url.indexOf(generatejwttoken) > -1) {
        if (request.url.indexOf(participantManagement) > -1) {
          request.headers.set("cognitoToken", store.getters.participantAWSToken);
        } else {
          request.headers.set("cognitoToken", store.getters.awsToken);
        }
      }
    }
    if (request && (request.method === "PUT" || request.method === "POST")) {
      const xssUtility = new XssFilterUtility();
      request = xssUtility.cleanRequestData(request);
    }

    VueInstance.prototype.$Progress.start();
    const getLoaderShow = showLoader(request);
    const getLoaderHide = hideLoader(request);
    if (getLoaderShow) {
      store.commit("SHOW_LOADER", true);
    }
    next(response => {
      if (response.status === 401 && response.data.type === "TOKENEXPIRED") {
        const { user, refreshToken } = store.getters;
        return getRefreshTokenFact(user.id, { refreshToken }).then(
          tokenReponse => {
            store.dispatch("userSetTokens", tokenReponse.body);
            return http(request);
          },
          () => {
            store.dispatch("userLogout");
          }
        );
      }
      if (response.status === 419) {
        const { participant, refreshToken } = store.getters;
        if (participant && participant.pid && participant.pid !== "") {
          const deviceId = localStorageService.getItem("pw-deviceId");
          return getParticipantRefreshTokenFact({
            refreshToken: refreshToken,
            pid: participant.pid,
            deviceId: deviceId
          }).then(
            tokenReponse => {
              store.dispatch("participantSetTokens", {
                accesstoken: tokenReponse.body.accesstoken,
                refreshtoken: tokenReponse.body.refreshtoken
              });
              return http(request);
            },
            () => {
              store.dispatch("participantLogout");
              return response;
            }
          );
        }
      }
      if (response.status === 401 && (!response.data.type || response.data.type !== "TOKENEXPIRED") && electronicSignatureSignIn === false) {
        store.dispatch("userLogout");
        VueInstance.prototype.$Progress.fail();
        store.commit("SHOW_LOADER", false);
      } else if (response.status <= 0 && !window.navigator.onLine) {
        toastr.warning("Sorry! No internet connection.");
        VueInstance.prototype.$Progress.fail();
        store.commit("SHOW_LOADER", false);
      } else if (response.status <= 0 || response.status === 501 || response.status === 502 || response.status === 503 || response.status === 504) {
        toastr.warning("Sorry! There is some server issue. Please try after some time.");
        VueInstance.prototype.$Progress.fail();
        store.commit("SHOW_LOADER", false);
      } else if (response.status === 500) {
        VueInstance.prototype.$Progress.fail();
        store.commit("SHOW_LOADER", false);
      } else {
        VueInstance.prototype.$Progress.finish();
        if (getLoaderHide) {
          store.commit("SHOW_LOADER", false);
        }
      }
      if (response.url.includes("/toggledfeatures")) {
        store.dispatch("setStudyToggledFeaturesData", response.body.studyFeatures);
        localStorage.removeItem("toggledFeatures");
        localStorage.setItem("toggledFeatures", JSON.stringify(response.body.studyFeatures));
      }
      return response;
    });
  });
}
